import { ICaseStatusLookupModel, ICaseStatusModel } from '../../../../interfaces/ICase';

import CaseFileCheckmateSelectHelper from '../../../../utilities/CaseFileCheckmateSelectHelper';
import CheckmateSelect from '../../../shared/CheckmateSelect';
import { IMultiSelectOption } from '../../../../interfaces/ILookup';
import { useGetCaseStatuses } from '../useGetCaseStatuses';

interface ICaseStatusControlProps {
    onChange: (caseStatus: ICaseStatusLookupModel | undefined) => void;
    readonly?: boolean;
    value: ICaseStatusModel | undefined;
}

export function CaseStatusControl(props: ICaseStatusControlProps) {
    const caseStatusApi = useGetCaseStatuses();
    const caseStatuses = caseStatusApi.data ?? [];

    const getCaseStatusLookupItem = (caseStatus?: ICaseStatusModel) => {
        if (caseStatus && caseStatus.status) {
            let filteredList = caseStatuses.filter(
                (x) => x.status && x.status.id == caseStatus.status.id
            );
            if (caseStatus.subStatus) {
                filteredList = filteredList.filter(
                    (x) => x.subStatus && x.subStatus.id == caseStatus.subStatus.id
                );
            }
            if (filteredList.length > 0) return filteredList[0];
        }
        return undefined;
    };

    const caseStatusLookupItem = getCaseStatusLookupItem(props.value);
    const availableOptions =
        CaseFileCheckmateSelectHelper.getCaseStatusOptionsForCheckmateSelect(caseStatuses);

    return (
        <div style={{ minWidth: 250, maxWidth: 300, width: '100%' }}>
            <CheckmateSelect
                name="caseStatus"
                options={availableOptions}
                onChange={(option: IMultiSelectOption) => {
                    const foundStatus = caseStatuses.find((cs) => cs.id === option?.id);
                    props.onChange(foundStatus);
                }}
                value={CaseFileCheckmateSelectHelper.getCaseStatusValue(
                    caseStatuses,
                    caseStatusLookupItem?.id ?? 0
                )}
                isDisabled={props.readonly}
            />
        </div>
    );
}
